import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AjustageContexte } from 'src/app/domain/Shared/ajustage-context';
import { AjustageOxygene } from 'src/app/domain/Shared/ajustage-oxygene';

@Component({
    selector: 'app-oxygene-calibration-box',
    templateUrl: './oxygene-calibration-box.component.html',
    styleUrls: ['./oxygene-calibration-box.component.scss']
})
export class OxygeneCalibrationBoxComponent implements OnInit {

    model: AjustageContexte = new AjustageContexte()
    public interventionTime;

    constructor(
        public dialogRef: MatDialogRef<OxygeneCalibrationBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {
    }

    ngOnInit(): void {
        this.model.AjustageOxygene = new AjustageOxygene()
        this.model.Date = new Date()
        this.setTime();
    }

    timeSet(event: string) {
        const time = event.split(':');

        this.model.Date = new Date(this.model.Date);
        this.model.Date.setHours(Number(time[0]), Number(time[1]));
        this.setTime();
    }

    setTime() {
        this.interventionTime = `${this.model.Date.getHours()}:${this.model.Date.getMinutes()}`;
    }

    CanAddNewMeasure() {
        return true
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        this.dialogRef.close(this.model);
    }
}
